<template>
    <v-container fluid class="main-body">
        <r-header></r-header>
        <HeaderPanel></HeaderPanel>
        <v-row>
            <v-tabs centered v-model="tab">
                <v-tab grow>Roscón 10K</v-tab>
                <v-tab grow>Roscón 7K</v-tab>
                <v-tab grow>Infantiles</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="contenido">
                <v-tab-item>
                    <v-card>
                        <v-card-title>
                            Listado de inscritos en la 10K
                            <v-spacer></v-spacer>
                            <v-text-field
                                    v-model="sRoscon"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                                :headers="headers.roscon"
                                :items="inscritosRoscon"
                                :search="sRoscon"
                                locale='es'
                                ref="insRoscon"
                        >
                            <template v-slot:item.acciones="{ item }">
                                <v-icon

                                        class="mr-3"
                                        @click="edita(item.id)"
                                >
                                    edit
                                </v-icon>

                                <v-icon

                                        class="mr-2"
                                        color="error"
                                        @click="askBorrar(item.id)"
                                >
                                    delete
                                </v-icon>

                                <v-icon
                                        v-if="item.equipo !== null"
                                        class="mr-2"
                                        color="blue"
                                        @click="salirEquipo(item.id)"
                                >
                                    launch
                                </v-icon>

                            </template>
                        </v-data-table>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat color="basil">
                        <v-card>
                            <v-card-title>
                                Listado de inscritos en la 7K
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="sCorta"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers.roscon"
                                    :items="inscritosCorta"
                                    :search="sCorta"
                                    locale='es'
                                    ref="insCorta"
                            >
                                <template v-slot:item.acciones="{ item }">
                                    <v-icon

                                            class="mr-3"
                                            @click="edita(item.id)"
                                    >
                                        edit
                                    </v-icon>

                                    <v-icon

                                            class="mr-2"
                                            color="error"
                                            @click="askBorrar(item.id)"
                                    >
                                        delete
                                    </v-icon>

                                    <v-icon
                                            v-if="item.equipo !== null"
                                            class="mr-2"
                                            color="blue"
                                            @click="salirEquipo(item.id)"
                                    >
                                        launch
                                    </v-icon>

                                </template>
                            </v-data-table>
                        </v-card>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <v-card-title>
                            Listado de inscritos en carreras infantiles
                            <v-spacer></v-spacer>
                            <v-text-field
                                    v-model="sInfantiles"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                                :headers="headers.infantil"
                                :items="inscritosInfantiles"
                                :search="sInfantiles"
                                locale='es'
                                ref="insInfantiles"
                        >
                            <template v-slot:item.acciones="{ item }">
                                <v-icon

                                        class="mr-3"
                                        @click="edita(item.id)"
                                >
                                    edit
                                </v-icon>

                                <v-icon

                                        class="mr-2"
                                        color="error"
                                        @click="askBorrar(item.id)"
                                >
                                    delete
                                </v-icon>

                            </template>
                        </v-data-table>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-row>
        <v-dialog v-model="borrar" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline myModal">
                        Se va a borrar de la carrera a:
                    </span>
                </v-card-title>
                <v-card-text>
                    <h3>
                        {{ `${corredor.nombre.toUpperCase()} ${corredor.apellidos.toUpperCase()},
                        ${corredor.dni.toUpperCase()} (referencia: ${corredor.referencia}) ` }}
                    </h3>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="borrarSi">BORRAR</v-btn>
                    <v-btn color="blue darken-1" text @click="borrarNo">CERRAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

    import { cookiesHelper } from "../../_helpers";
    import { panelService } from "../../_services/panel";
    import RHeader from "../../components/shared/HeaderComponent";
    import HeaderPanel from "../../components/shared/HeaderPanel";

    export default {
        name: "Panel",
        components: {HeaderPanel, RHeader},
        data() {
            return {
                tab: 0,
                roscon: [],
                sRoscon:'',
                corta: [],
                sCorta: '',
                infantiles: [],
                sInfantiles: '',
                borrar: false,
                corredor: {
                    nombre: '',
                    apellidos: '',
                    dni:'',
                    referencia:''
                },
                headers: {
                    roscon: [
                        { text: 'Dorsal', value: 'dorsal' },
                        { text: 'Nombre', value: 'nombre' },
                        { text: 'Apellidos', value: 'apellidos' },
                        { text: 'DNI', value: 'dni' },
                        { text: 'Referencia', value: 'referencia', sortable: false },
                        { text: 'Categoría', value: 'categoria' },
                        { text: 'Federado', value: 'federado', sortable: false },
                        { text: 'Talla', value: 'talla', sortable: false },
                        { text: 'Equipo', value: 'nombreEquipo', sortable: false },
                        { text: 'Editar', value: 'acciones', sortable: false }

                    ],
                    infantil:[
                        { text: 'Dorsal', value: 'dorsal' },
                        { text: 'Nombre', value: 'nombre' },
                        { text: 'Apellidos', value: 'apellidos' },
                        { text: 'DNI del Tutor', value: 'dni_tutor' },
                        { text: 'Referencia', value: 'referencia', sortable: false },
                        { text: 'Categoría', value: 'categoria' },
                        { text: 'Federado', value: 'federado', sortable: false },
                        { text: 'Talla', value: 'talla', sortable: false },
                        { text: 'Editar', value: 'acciones', sortable: false },
                    ]
                },
            }
        },
        created() {
            const c = cookiesHelper.getCookie('token')

            if (c=='') {
                this.$router.push('login')
            }else {
                panelService.getInscritos(c).then( res => {
                    //eslint-disable-next-line
                    if (res.status !== 401) {
                        this.roscon = res.data.roscon
                        this.corta = res.data.corta
                        this.infantiles = res.data.infantiles
                    }
                })
            }
        },
        computed: {
            inscritosRoscon() {
                return this.roscon
            },
            inscritosCorta() {
                return this.corta
            },
            inscritosInfantiles() {
                return this.infantiles
            }
        },
        methods: {
            edita(id) {
                // Infantiles
                if (this.tab === 2)
                    this.$router.push({ name:'editaInfantil', params: { id, carrera: this.tab+1 } })
                // Roscon y 7k
                else
                    this.$router.push({ name: 'editar', params: { id, carrera: this.tab+1 } })
            },
            askBorrar(id) {

                switch (this.tab) {
                    case 2: this.corredor = this.infantiles.find( ins => ins.id == id ); break;
                    case 1: this.corredor = this.corta.find( ins => ins.id == id ); break;
                    default: this.corredor = this.roscon.find( ins => ins.id == id ); break;
                }
                this.borrar = true
            },
            borrarSi() {
              this.borrar = false
                panelService.deleteInscripcion(this.tab+1, this.corredor.id, this.token).then( result => {
                    if(result.data.success) {
                        switch (this.tab) {
                            case 0: this.roscon.splice(
                                this.roscon.findIndex(ele => ele.id === this.corredor.id),1)
                                break;
                            case 1: this.corta.splice(
                                this.corta.findIndex(ele => ele.id === this.corredor.id),1)
                                break;
                            default: this.infantiles.splice(
                                this.infantiles.findIndex(ele => ele.id === this.corredor.id),1)
                                break;
                        }
                    }
                })
            },
            borrarNo() {
                this.borrar = false
            },
            salirEquipo(id) {
                panelService.unsuscribeCorredor(id).then( result => {
                    if(result.data.success) {
                        switch (this.tab) {
                            case 0: this.roscon.forEach( (item) => {
                                if (parseInt(item.id) === parseInt(id)){
                                    item.equipo = item.nombreEquipo = null
                                }
                            })
                                break;
                            case 1: this.corta.forEach( (item) => {
                                if (parseInt(item.id) === parseInt(id)){
                                    item.equipo = item.nombreEquipo = null
                                }
                            })
                                break;
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "./../../_static/base";
    .contenido {
        width: 90%;
        margin: 0 auto;
    }
</style>